require('../../../node_modules/bootstrap/dist/css/bootstrap.min.css');
import AppHeader from '../AppHeader'
import AppFooter from '../AppFooter'
import constant from '../../store/constant'

export default {
  name: 'app',
  created: function() {
    //houkokusyo-newをhoukokusyoにリダイレクト
    if (location.hostname.match(/-new/) != null) {
      location.hostname = location.hostname.replace(/-new/, '')
    }
    this.healthcheck()
    if (!this.$store.getters.isLogin && window.localStorage.getItem('access_token')) {
      this.authorize()
    }
    // 画面タップ時にbootstrapのトグルメニューを閉じる
    if (window.innerWidth <= 769) {
      document.body.onclick = function() {
        $(".navbar-collapse").collapse('hide')
      }
    }
  },
  computed: {
    notifications () {
      return this.$store.getters.notifications
    },
    maintenance () {
      return this.$store.getters.maintenance
    }
  },
  components: {
    AppHeader,
    AppFooter
  },
  methods: {
    authorize: function() {
      this.$store.dispatch('AUTHORIZE')
    },
    healthcheck: function() {
      this.$store.dispatch('HEALTHCHECK')
    }
  },
  watch: {
    '$route' (to, from) {
      var shopName = this.$store.getters.currentShopName
      document.getElementById('help-modal-btn').style['display'] = 'none';
      // 全店舗表示
      if (shopName === null) {
        for (var i = 0; i < constant.SELECT_SHOP_PATHS.length; i++) {
          var path = constant.SELECT_SHOP_PATHS[i]
          if (path.test(to.fullPath)) {
            // 他店舗切替に遷移
            this.$router.push({ path: '/shops' })
            break
          }
        }
      }

      // ページ切替によるloading抑止
      if (to.fullPath !== from.fullPath) {
        var commonAjaxLoading = document.getElementById('commonAjaxLoading')
        if (commonAjaxLoading && commonAjaxLoading.style['display'] === 'block') {
          commonAjaxLoading.style['display'] = 'none'
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/app.js